<template>
  <c-box>
    <c-heading as="h1">Could not login to iLOQ Partner Portal</c-heading>
    <c-text>
      Please ask
      <c-link href="mailto:customer.service@iloq.com">iLOQ (customer.service@iloq.com)</c-link> to
      check user configuration for <b>{{ $router.currentRoute.query.user }}</b
      >.
    </c-text>
    <c-text><c-link href="/logout">Back to login page</c-link></c-text>
  </c-box>
</template>

<script lang="ts">
import { CBox, CHeading, CLink, CText } from "@chakra-ui/vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "PartnerFailure",
  components: {
    CHeading,
    CText,
    CBox,
    CLink,
  },
});
</script>
